import { baseResourceOptions } from './utils';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import createCollectionResource from '../shared/createResource';
import { SidekickIntegration } from 'src/models/Sidekick/SidekickIntegration';

const sidekickIntegrationsResource = createCollectionResource<SidekickIntegration>({
  name: 'sidekickIntegrations',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/integrations',
  type: SidekickIntegration,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickIntegrationsResource;
